// root
const r = '/admin/products';

export const adminProductRoutes = {
  // admin products list
  list: r,
  // detail product
  detail: (id: string) => `${r}/${id}`,
  // edit product category
  category: (id: string) => `${r}/${id}/category`,
  // edit product main information (title, description, etc)
  mainInformation: (id: string) => `${r}/${id}/main-information`,
  // edit product photos/images
  photos: (id: string) => `${r}/${id}/photos`,
  // product review
  review: (id: string) => `${r}/${id}/review`,
  // product options list
  options: (id: string) => `${r}/${id}/options`,
  // product option setup
  optionSetup: (id: string, optId: string) =>
    `${r}/${id}/options/${optId}/setup`,
  // product option meeting point
  optionMeetingPoint: (id: string, optId: string) =>
    `${r}/${id}/options/${optId}/meeting-point`,
  // product option availability and pricing
  optionAvailability: (id: string, optId: string) =>
    `${r}/${id}/options/${optId}/availability-and-pricing`,
  // product option schedule
  optionSchedule: (id: string, optId: string) =>
    `${r}/${id}/options/${optId}/schedule`,
} as const;
